import React from "react";
import ReactApexChart from "react-apexcharts";

const pieChartColors = [
  "#008FFB",
  "#00E396",
  "#FEB019",
  "#FF4560",
  "#775DD0",
  "#3F51B5",
  "#546E7A",
  "#D4526E",
  "#8D5B4C",
  "#F86624",
  "#D7263D",
  "#1B998B",
  "#2E294E",
  "#F46036",
  "#E2C044",
  "#FF5733",
  "#33FF57",
  "#3357FF",
  "#FF33A8",
  "#A833FF",
];

const PieChart = ({
  chartOptions = {},
  chartSeries = [],
  type = "pie",
  prefix = "",
}) => {
  const hasData = Array.isArray(chartSeries) && chartSeries.length > 0;

  const baseOptions = {
    ...chartOptions,
    colors: pieChartColors,
    legend: {
      show: false,
    },
  };

  const emptyOptions = {
    chart: { type: "pie" },
    colors: pieChartColors,
    labels: ["No Data"],
    tooltip: {
      enabled: true,
      y: { formatter: () => "0.00%" },
    },
    dataLabels: {
      formatter: () => "0.0%",
      style: { colors: ["#ffffff"] },
    },
    fill: { opacity: 1 },
    legend: { show: false },
  };

  return (
    <div
      style={{
        width: "100%",
      }}
      className="py-2"
    >
      <ReactApexChart
        options={hasData ? baseOptions : emptyOptions}
        series={hasData ? chartSeries : [100]}
        type={type}
        height={300}
      />

      {hasData && chartOptions.labels && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "10px 20px",
            padding: "10px",
            marginTop: "16px",
            maxHeight: "200px",
            overflowY: "auto",
            background: "#fff",
            width: "100%",
            fontSize: "14px",
          }}
        >
          {chartOptions.labels.map((label, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  maxWidth: "70%",
                }}
                title={label}
              >
                <span
                  style={{
                    display: "inline-block",
                    width: "12px",
                    height: "12px",
                    backgroundColor:
                      pieChartColors[index % pieChartColors.length],
                    marginRight: "6px",
                    borderRadius: "50%",
                    flexShrink: 0,
                  }}
                ></span>
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                  {label}
                </span>
              </div>

              <div style={{ flexShrink: 0, marginLeft: "8px" }}>
                {prefix}
                {chartSeries[index]}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default PieChart;
